module.exports = __webpack_public_path__ + "static/img/img30.20d7d8ae.png";